// libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import SuggestionsLinks from './SuggestionsLinks';
import SuggestionsMedias from './SuggestionsMedias';

// Props and Context
const propTypes = {
  links: PropTypes.array,
  medias: PropTypes.array,
};
const defaultProps = {
  links: [],
  medias: [],
};
const contextTypes = {
  t: PropTypes.func,
};

function Suggestions({ links, medias }, { t }) {
  return (
    <div className="annex">
      <h5 className="annex__heading">{t('pages.single.suggestions')}</h5>
      <div className="suggestions">
        {links.length > 0 &&
          <SuggestionsLinks links={links} />
        }
        {medias.length > 0 &&
          <SuggestionsMedias medias={medias} />
        }
      </div>
    </div>
  );
}

Suggestions.propTypes = propTypes;
Suggestions.defaultProps = defaultProps;
Suggestions.contextTypes = contextTypes;

export default Suggestions;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/Suggestions.js